import { useNavigate } from "react-router-dom";
import { useData } from "context/data.context";
import { CaretRightIcon } from "@phosphor-icons/react";

const GrowthCard = () => {
  const { networthCurrent } = useData();
  const navigate = useNavigate();

  const { growthStart } = networthCurrent;
  const startYear = growthStart?.year;
  const growthYears = growthStart ? new Date().getFullYear() - growthStart.year : 0;

  const annualisedGrowth = (() => {
    if (!growthStart || growthYears <= 0 || networthCurrent.total <= 0) return null;
    const val = (Math.pow(networthCurrent.total / growthStart.total, 1 / growthYears) - 1) * 100;
    return isFinite(val) ? val.toFixed(1) : null;
  })();

  return (
    <div className="card r4-3 flex col space pointer" onClick={() => { navigate('/timeline'); window.scrollTo(0, 0); }}>
      <div className="flex row space">
        <div>
          <p className="large">Growth</p>


          <p className="regular o80">{startYear ? `since ${startYear}` : 'Annually'}</p>
        </div>
        <p className="large"><CaretRightIcon /></p>
      </div>
      <div className="flex row space">
      <p className="number xxxlarge">{annualisedGrowth !== null ? `${annualisedGrowth}%` : '—'}</p>
      {/* <div className="  "><p className="flag">per year</p></div> */}
      </div>
    </div>
  );
};

export default GrowthCard;
